/*
  Outdoor Creative Market page behaviour (templates/page.creative-market.json). Loaded once,
  deferred, by sections/cm-page.liquid, which also emits the page config as JSON (#cm-config):
    endpoint      -- POST https://adju.com/api/market (SposMobileSite; spec: SPOS repo
                     docs/handoff/creative-market/SPEC.md)
    optionsUrl    -- GET https://adju.com/api/market/options -> {markets:[...]}, the markets
                     taking applications (empty = closed)
    maxPhotos     -- 3
    maxPhotoBytes -- 10 MB, the endpoint's per-file cap
    markets       -- the page's market blocks [{key, label, date}], used to label the
                     endpoint's market names and as the fallback list when it cannot be reached

  Plain JavaScript, no dependencies. Every handler is delegated from the document and scoped to
  the cm-* markup, so it keeps working when the theme editor re-renders the section.

  The form follows assets/tt-landing.js and assets/bc-landing.js (the lead forms) -- the same
  trap field, the same no-custom-headers fetch (no CORS preflight), the same 200 {ok} /
  400 {field, message} contract -- but posts multipart FormData because of the photos. This
  page has no ad attribution and no Google Ads: vendors are not an ad audience.
*/
(function () {
  'use strict';

  if (window.cmMarketLoaded) return;
  window.cmMarketLoaded = true;

  var config = {};
  try {
    var cfgEl = document.getElementById('cm-config');
    if (cfgEl) config = JSON.parse(cfgEl.textContent || '{}');
  } catch (e) {
    config = {};
  }
  var MAX_PHOTOS = config.maxPhotos || 3;
  var MAX_PHOTO_BYTES = config.maxPhotoBytes || 10485760;

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  /* ================= FAQ: one answer open at a time =================
     Native <details>, so it works without this; the script only closes the others.
     `toggle` does not bubble, hence the capturing listener. */
  document.addEventListener(
    'toggle',
    function (e) {
      var item = e.target;
      if (!item || !item.open || !item.parentNode || !item.matches || !item.matches('[data-cm-faq] > details')) return;
      Array.prototype.forEach.call(item.parentNode.children, function (other) {
        if (other !== item && other.tagName === 'DETAILS') other.open = false;
      });
    },
    true
  );

  /* ================= which markets are open =================
     The endpoint owns the list: GET optionsUrl -> {markets: ["Holiday 2026", ...]}. The
     checkboxes are redrawn from it, labelled with the page's market blocks where the key
     matches. An empty list means nobody is taking applications: the form gives way to the
     closed notice and the vendor alert above the hero is hidden. A failed call (the endpoint not deployed yet, a network error) leaves the
     page's own list in place, so the page still previews and the endpoint still decides. */
  function marketInfo(key) {
    var list = config.markets || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].key && list[i].key.toLowerCase() === String(key).toLowerCase()) return list[i];
    }
    return null;
  }

  function renderMarkets(form, names) {
    var list = form.querySelector('[data-cm-market-list]');
    if (!list) return;
    var wasChecked = {};
    list.querySelectorAll('input[name="market"]').forEach(function (cb) {
      if (cb.checked) wasChecked[cb.value.toLowerCase()] = true;
    });
    list.textContent = '';
    names.forEach(function (name, index) {
      var info = marketInfo(name);
      var label = document.createElement('label');
      label.className = 'cm-check';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.name = 'market';
      cb.value = name;
      // keep what the visitor ticked; on first draw tick the page's "next" market (the first one printed)
      cb.checked = wasChecked[name.toLowerCase()] || (index === 0 && !Object.keys(wasChecked).length);
      var words = document.createElement('span');
      var strong = document.createElement('strong');
      strong.textContent = info && info.label ? info.label : name;
      words.appendChild(strong);
      if (info && info.date) {
        var note = document.createElement('span');
        note.className = 'cm-check__note';
        note.textContent = info.date;
        words.appendChild(document.createTextNode(' '));
        words.appendChild(note);
      }
      label.appendChild(cb);
      label.appendChild(words);
      list.appendChild(label);
    });
  }

  function loadMarkets(page) {
    var form = page.querySelector('#cm-apply-form');
    if (!form || !config.optionsUrl || !window.fetch) return;
    fetch(config.optionsUrl, { method: 'GET', mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('options ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var names = data && Array.isArray(data.markets) ? data.markets.filter(Boolean) : null;
        if (!names) return;
        var closed = page.querySelector('[data-cm-closed]');
        var vendorAlert = page.querySelector('[data-cm-vendor-alert]');
        if (vendorAlert) vendorAlert.hidden = !names.length;
        if (!names.length) {
          form.hidden = true;
          if (closed) closed.hidden = false;
          return;
        }
        form.hidden = false;
        if (closed) closed.hidden = true;
        renderMarkets(form, names);
      })
      .catch(function () {
        /* the page's own list stands */
      });
  }

  /* ================= the photos =================
     One to three pictures. Checked here before the post (count, type, size) so a phone on
     LTE does not upload 40 MB to be told no; the endpoint checks again. A small preview strip
     shows what will be sent. */
  function photoInput(form) {
    return form.querySelector('input[type="file"][name="photos"]');
  }

  function describePhotos(form) {
    var input = photoInput(form);
    var strip = form.querySelector('[data-cm-photos]');
    var count = form.querySelector('[data-cm-photo-count]');
    if (!input) return;
    var files = input.files ? Array.prototype.slice.call(input.files) : [];
    if (count) count.textContent = files.length ? files.length + ' of ' + MAX_PHOTOS + ' chosen' : '';
    if (!strip) return;
    strip.querySelectorAll('img').forEach(function (img) {
      if (img.src && img.src.indexOf('blob:') === 0 && window.URL && URL.revokeObjectURL) URL.revokeObjectURL(img.src);
    });
    strip.textContent = '';
    if (!window.URL || !URL.createObjectURL) return;
    files.slice(0, MAX_PHOTOS).forEach(function (file) {
      if (!/^image\//.test(file.type)) return;
      var li = document.createElement('li');
      var img = document.createElement('img');
      img.alt = '';
      img.src = URL.createObjectURL(file);
      li.appendChild(img);
      strip.appendChild(li);
    });
  }

  function checkPhotos(form) {
    var input = photoInput(form);
    if (!input) return '';
    var files = input.files ? Array.prototype.slice.call(input.files) : [];
    if (!files.length) return 'Please add at least one photo of your work.';
    if (files.length > MAX_PHOTOS) return 'Please choose up to ' + MAX_PHOTOS + ' photos.';
    for (var i = 0; i < files.length; i++) {
      if (files[i].size > MAX_PHOTO_BYTES) return '"' + files[i].name + '" is over the 10 MB limit. A smaller copy or a phone photo is fine.';
      if (files[i].type && !/^image\/(jpeg|png|webp|gif|bmp)$/.test(files[i].type)) return '"' + files[i].name + '" is not a photo we can read. Please use JPEG or PNG.';
    }
    return '';
  }

  document.addEventListener('change', function (e) {
    var input = closest(e.target, '#cm-apply-form input[type="file"][name="photos"]');
    if (!input) return;
    var form = closest(input, 'form');
    describePhotos(form);
    fieldError(form, 'photos', checkPhotos(form) && input.files && input.files.length ? checkPhotos(form) : '');
  });

  /* ================= the application ================= */
  var TEXT_FIELDS = ['firstName', 'lastName', 'business', 'email', 'phone', 'productsOther', 'notes', 'website', 'source'];
  var ERROR_FIELDS = ['firstName', 'lastName', 'business', 'email', 'phone', 'market', 'products', 'photos'];

  function fieldError(form, name, message) {
    var input = form.elements[name];
    if (input && typeof input.length === 'number' && !input.tagName) input = input[0]; // a checkbox group
    var err = form.querySelector('[data-cm-error="' + name + '"]');
    if (input) {
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
    if (err) err.textContent = message || '';
  }

  function clearErrors(form) {
    ERROR_FIELDS.forEach(function (n) {
      fieldError(form, n, '');
    });
    var status = form.querySelector('[data-cm-status]');
    if (status) status.textContent = '';
  }

  function statusMessage(form, text, withEmail) {
    var status = form.querySelector('[data-cm-status]');
    if (!status) return;
    var email = form.getAttribute('data-vendor-email') || '';
    status.textContent = '';
    status.appendChild(document.createTextNode(text));
    if (withEmail && email) {
      status.appendChild(document.createTextNode(' Or email us at '));
      var a = document.createElement('a');
      a.href = 'mailto:' + email;
      a.textContent = email;
      status.appendChild(a);
      status.appendChild(document.createTextNode('.'));
    }
  }

  function failMessage(form) {
    statusMessage(form, 'Sorry, we could not send your application just now. Please try again in a moment.', true);
  }

  function phoneDigits(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d;
  }

  function checkedValues(form, name) {
    var out = [];
    form.querySelectorAll('input[type="checkbox"][name="' + name + '"]').forEach(function (cb) {
      if (cb.checked) out.push(cb.value);
    });
    return out;
  }

  function validate(form) {
    var ok = true;
    var first = null;
    var mark = function (name, msg) {
      fieldError(form, name, msg);
      if (!first) {
        var el = form.elements[name];
        first = el && typeof el.length === 'number' && !el.tagName ? el[0] : el;
      }
      ok = false;
    };
    if (!form.elements.firstName.value.trim()) mark('firstName', 'Please enter your first name.');
    if (!form.elements.lastName.value.trim()) mark('lastName', 'Please enter your last name.');
    if (!form.elements.business.value.trim()) mark('business', 'Please enter your business or booth name.');
    var email = form.elements.email.value.trim();
    if (!email) mark('email', 'Please enter your email: that is how we reply.');
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) mark('email', 'Please check your email address.');
    if (phoneDigits(form.elements.phone.value).length !== 10) mark('phone', 'Please enter a 10-digit phone number.');
    if (!checkedValues(form, 'market').length) mark('market', 'Please tick at least one market.');
    if (!checkedValues(form, 'products').length) mark('products', 'Please tick at least one category.');
    var photoProblem = checkPhotos(form);
    if (photoProblem) mark('photos', photoProblem);
    if (first && first.focus) first.focus();
    return ok;
  }

  var sending = false;
  document.addEventListener('submit', function (e) {
    var form = closest(e.target, '#cm-apply-form');
    if (!form) return;
    e.preventDefault();
    if (sending) return;
    clearErrors(form);
    if (!validate(form)) return;
    if (!config.endpoint || !window.FormData) {
      failMessage(form);
      return;
    }

    // multipart because of the photos; still no custom headers, so no CORS preflight
    var body = new FormData();
    TEXT_FIELDS.forEach(function (n) {
      var el = form.elements[n];
      if (el) body.append(n, el.value.trim());
    });
    checkedValues(form, 'market').forEach(function (v) {
      body.append('market', v);
    });
    checkedValues(form, 'products').forEach(function (v) {
      body.append('products', v);
    });
    var input = photoInput(form);
    if (input && input.files) {
      Array.prototype.slice.call(input.files, 0, MAX_PHOTOS).forEach(function (file) {
        body.append('photos', file, file.name);
      });
    }
    body.append('elapsedMs', String(Math.round(window.performance && performance.now ? performance.now() : 99999)));
    body.append('page', window.location.pathname);

    var submitBtn = form.querySelector('button[type="submit"]');
    var label = submitBtn ? submitBtn.textContent : '';
    sending = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
    }

    var controller = 'AbortController' in window ? new AbortController() : null;
    // 90 s: three phone photos over LTE plus the server shrinking them. A timeout tells the
    // applicant to retry even when the application was saved, so wait generously.
    var timer = setTimeout(function () {
      if (controller) controller.abort();
    }, 90000);

    fetch(config.endpoint, {
      method: 'POST',
      body: body,
      mode: 'cors',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined,
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { status: res.status, data: data || {} };
          });
      })
      .then(function (r) {
        if (r.status === 200 && r.data.ok) {
          onSuccess(form);
          return;
        }
        if (r.status === 400 && r.data.field && (form.elements[r.data.field] || form.querySelector('[data-cm-error="' + r.data.field + '"]'))) {
          fieldError(form, r.data.field, r.data.message || 'Please check this field.');
          var el = form.elements[r.data.field];
          if (el && typeof el.length === 'number' && !el.tagName) el = el[0];
          if (el && el.focus) el.focus();
          return;
        }
        if (r.status === 503 && r.data.retry) {
          statusMessage(form, r.data.message || 'The server is busy processing other pictures. Please try again in a moment.', false);
          return;
        }
        failMessage(form);
      })
      .catch(function () {
        failMessage(form);
      })
      .then(function () {
        clearTimeout(timer);
        sending = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = label;
        }
      });
  });

  function onSuccess(form) {
    var firstName = form.elements.firstName.value.trim();
    if (window.dataLayer) window.dataLayer.push({ event: 'cm_application_submitted' });
    var success = document.getElementById('cm-apply-success');
    if (success) {
      var nameSlot = success.querySelector('[data-cm-first-name]');
      if (nameSlot) nameSlot.textContent = firstName ? ', ' + firstName : '';
      form.hidden = true;
      success.hidden = false;
      success.focus();
    }
  }

  /* ================= hero animation =================
     The wide banner's animated edition (sections/cm-page.liquid) ships with preload="none" and
     no autoplay, so nothing downloads until it is started here -- and it is started only where
     it is seen: 750px and up (phones show the portrait art). It plays for every desktop
     visitor, reduced-motion setting or not, like the Transformer Table hero (JT, 2026-10-04);
     the button is the way to stop it. It fades in over the still once frames are playing. A
     video the visitor paused stays paused. A browser will not start a video in a background
     tab, so it is started again when the tab is shown, and the width query is watched so a
     resize across 750px takes effect at once. */
  var wideQuery = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;

  function heroAnimation(page) {
    return { video: page.querySelector('[data-cm-hero-video]'), toggle: page.querySelector('[data-cm-video-toggle]') };
  }

  function syncHeroToggle(video, toggle) {
    if (!toggle) return;
    toggle.classList.toggle('is-paused', video.paused);
    toggle.setAttribute('aria-label', video.paused ? 'Play animation' : 'Pause animation');
  }

  function syncHero(page) {
    var hero = heroAnimation(page);
    var video = hero.video;
    if (!video) return;
    if (!video.cmReady) {
      video.cmReady = true;
      video.muted = true;
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });
      video.addEventListener('play', function () {
        syncHeroToggle(video, hero.toggle);
      });
      video.addEventListener('pause', function () {
        syncHeroToggle(video, hero.toggle);
      });
    }
    var wanted = !!wideQuery && wideQuery.matches;
    if (hero.toggle) {
      hero.toggle.hidden = !wanted;
      syncHeroToggle(video, hero.toggle);
    }
    if (!wanted) {
      if (!video.paused) video.pause();
      video.classList.remove('is-playing');
      return;
    }
    if (video.cmPausedByVisitor || !video.paused || document.visibilityState === 'hidden') return;
    var started = video.play();
    // a refused start (iOS Low Power Mode, data saver) leaves the still and the play button
    if (started && started.catch) started.catch(function () {});
  }

  function syncHeroes() {
    document.querySelectorAll('[data-cm-page]').forEach(syncHero);
  }

  if (wideQuery && wideQuery.addEventListener) wideQuery.addEventListener('change', syncHeroes);
  else if (wideQuery && wideQuery.addListener) wideQuery.addListener(syncHeroes);
  document.addEventListener('visibilitychange', syncHeroes);

  document.addEventListener('click', function (e) {
    var toggle = closest(e.target, '[data-cm-video-toggle]');
    if (!toggle) return;
    var page = closest(toggle, '[data-cm-page]');
    var video = page ? heroAnimation(page).video : null;
    if (!video) return;
    video.cmPausedByVisitor = !video.paused;
    if (video.paused) {
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    } else {
      video.pause();
    }
  });

  /* ================= start ================= */
  function init() {
    document.querySelectorAll('[data-cm-page]').forEach(function (page) {
      loadMarkets(page);
      var form = page.querySelector('#cm-apply-form');
      if (form) describePhotos(form);
      syncHero(page);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // the theme editor swaps the section's markup in place
  document.addEventListener('shopify:section:load', init);
})();
